import { render, staticRenderFns } from "./ChooseMedPart.vue?vue&type=template&id=7a38cbb2&"
import script from "./ChooseMedPart.vue?vue&type=script&lang=js&"
export * from "./ChooseMedPart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports